import registeredSettings from '../helpers/registered-settings';

const getElementSettings = () => registeredSettings;

export default getElementSettings;
